<template>
  <div>
    <div v-if="advertiseUrl">
      <img :src="advertiseUrl" alt="" @click="imgClick()" class="land-page-img" />
    </div>
  </div>
</template>

<script>
import {
  getWeChatScheme,
} from "../../api";
import {launchAppLottery} from '../../utils/index';
import {getAdvertiseApi} from "@/api";
import { Base64 } from 'js-base64'

export default {
  name: 'TransferPage',
  data(){
    return {
      advertiseUrl: "",
      code: "",
      appletUrl: '',
      brand: this.$config.env.VUE_APP_BRAND,
    }
  },
  async mounted() {
      this.getCode()
      this.imgClick()
  },
  methods: {
      getCode() {
          if (this.$route.query.c == 1) {
          if (this.brand == 'COTTI') {
              this.code = 'cotti-common-product-redirect'
              this.getImg()
          } else {
              this.code = 'teacat-common-product-redirect'
              this.getImg()
          }
      } else if (this.$route.query.c == 2) {
          if (this.brand == 'COTTI') {
              this.code = 'cotti-mkt-luckydraw-redirect'
              this.getImg()
          } else {
              this.code = 'teacat-mkt-luckydraw-redirect'
              this.getImg()
          }
      }
      },
      async getImg(){
          const {data} = await getAdvertiseApi({code: this.code})
          this.advertiseUrl = data[0]?.url || ''
      },
    imgClick() {
      this.handleJumpAction(this.$route.query.page, this.$route.query.type)

    },
    handleJumpAction(jumpLink, jumpType) {
      if (jumpLink) {
        this.appletUrl = Base64.decode(jumpLink)
        if (jumpType) {
          if (jumpType == 3 || jumpType == '3') {
                // this.appletUrl = jumpLink;
                this.openApp(this.appletUrl)
              } else if (jumpType == 4 || jumpType == '4') {
                // this.appletUrl = Base64.decode(jumpLink)
                this.openApplet(this.appletUrl)
              } else if (jumpLink == 7 || jumpType == '7') {
                // this.appletUrl = Base64.decode(jumpLink)
                this.onAli(this.appletUrl)
              }
        } else {
          window.location.href = jumpLink;
        }
      }
    },
    openApplet(appletUrl) {
      try {
        const path = appletUrl.split('?')[0]
        const query = appletUrl.split('?')[1]
        const params = JSON.stringify({ path: appletUrl })
        getWeChatScheme({ path, query }).then(res => {
          if (res.data.scheme) {
            location.href = res.data.scheme;
          } else {
            this.$toast({ message: "请先安装微信" });
          }
        })
      }catch (e) {
        this.$toast({ message: "请先安装微信" });
      }
    },
    // 跳转app
    openApp(appletUrl) {
      const path = appletUrl.split('?')[0]
      const query = appletUrl.split('?')[1]
      const params = JSON.stringify({ path: appletUrl })
      launchAppLottery('PAGES', Base64.encode(params), true)
    },
    // 跳转支付宝小程序
    onAli(appletUrl) {
      let params =`alipays://platformapi/startapp?appId=2021004123660926&page=/${appletUrl}`
      window.location.href = `https://ds.alipay.com/?scheme=${params}`
    },
  }
}
</script>

<style lang="scss" scoped>
.land-page-img{
  width: 100%;
}
</style>

